import { FirebaseAuthentication } from "./authentication";
import { firebaseConfig } from "../../../../appV2/Auth/firebase";

function initFirebaseAuth(): FirebaseAuthentication {
  const firebaseAuth: FirebaseAuthentication = new FirebaseAuthentication(
    firebaseConfig as unknown as Record<string, string>
  );

  return firebaseAuth;
}

/**
 * `firebaseAuth` depends on `isCapacitorPlatform()`, which depends
 *  on some mocks tests.
 * This mock has to be defined prior to running tests. Our
 * testing configuration doesn't evaluate it right away, so
 * we need to lazy evaluate the singleton.
 */
let firebaseAuthSingleton: FirebaseAuthentication;

export function getFirebaseSingleton() {
  if (!firebaseAuthSingleton) {
    firebaseAuthSingleton = initFirebaseAuth();
  }
  return firebaseAuthSingleton;
}
